// extracted by mini-css-extract-plugin
export default {"pageTitle":"Layout_pageTitle__QVrgK"};